import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A roadtrip: second leg",
  "description": "",
  "published": "2012-07-31T00:00:00.000Z",
  "redirect_from": ["/blog/a-roadtrip-second-leg/swizec/4953"],
  "categories": "Adriatic Sea, Cetina, Croatia, Dalmatia, Dubrovnik, Goat, Omiš, Roadtrip, Split Croatia, Travel + Events, Travel and Tourism",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1826-1024x768.jpg",
        "alt": "Highway towards Dubrovnik",
        "title": "Highway towards Dubrovnik"
      }}></img></p>
    <p>{`Despite `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923",
        "title": "A roadtrip: wherein Swizec is not to be trusted with important objects without supervision"
      }}>{`The Key Debacle`}</a>{` we made it to Dubrovnik last night - only a day late.`}</p>
    <p>{`And just as well, I was getting rather fed up with the lack of proper internet access in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=43.4333333333,16.6833333333&spn=0.1,0.1&q=43.4333333333,16.6833333333%20(Omi%C5%A1)&t=h",
        "title": "Omiš"
      }}>{`Omiš`}</a>{`. Whole town, only two bars with actual wifi access. Alright, there was also a restaurant with wifi. A very expensive restaurant ... and who goes to hang out at a restaurant while they do stuff online anyway, that's just not how it's done.`}</p>
    <p>{`Despite everyone's advice on how roadtrips are supposed to work and what makes them interesting, we took as much of the highway down to Dubrovnik as we possibly could. The only other road tends to get really stuffed up with traffic in the evenings.`}</p>
    <p>{`We've heard rumours of six hour traffic jams. Definitely not something you want to see on a drive that's going to take three hours even if everything goes according to plan.`}</p>
    <p>{`Oh and the night before - this would make it the day before yesterday - we went to see `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=43.5,16.4333333333&spn=0.1,0.1&q=43.5,16.4333333333%20(Split%2C%20Croatia)&t=h",
        "title": "Split, Croatia"
      }}>{`Split`}</a>{` and its infamous palace thing. Not impressed. Not at all. Split looks like a messy town full of too many people, very insane traffic, poorly marked roads and everything just had that `}<em parentName="p">{`"We haven't cleaned this since it was built 30 years ago"`}</em>{` feel.`}</p>
    <p>{`The palace itself was kind of pretty, but there were too many tourists and most of the views were obscured by the stands selling the same old stuff I've been seeing at every Croatian seaside town since I was 5 years old.`}</p>
    <p>{`Contrasting this with Dubrovnik, which looks incredibly clean and very posh. Even though it looks to be much smaller than Split, I have a feeling of being very well off as a town. Everything is nice and clean. There's pretty boats everywhere and all the houses look pretty damn good and finished.`}</p>
    <p>{`And the traffic makes sense! This far south and `}<em parentName="p">{`the traffic makes sense!`}</em></p>
    <p>{`That's just amazing if you ask me.`}</p>
    <p>{`Now excuse me while I go to the beach for the first time ... on the 6th day of this seaside trip.`}</p>
    <p>{`PS: putting up a large and complex tent in the dark is silly business`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1727-768x1024.jpg",
        "alt": "We skinny dipped in Cetina, and by skinny dipped I mean we put our skinny toes in there",
        "title": "We skinny dipped in Cetina, and by skinny dipped I mean we put our skinny toes in there"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo5-e1343743830702-764x1024.jpg",
        "alt": "Something or another in Split",
        "title": "Something or another in Split"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1756-1024x768.jpg",
        "alt": "Split employs tourists to polish its floors",
        "title": "Split employs tourists to polish its floors"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/glava.jpg",
        "alt": "Pan ... maybe, probably",
        "title": "Pan ... maybe, probably"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1830-1024x768.jpg",
        "alt": "Bike and Goat, the cheap way to travel",
        "title": "Bike and Goat, the cheap way to travel"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_18541-1024x768.jpg",
        "alt": "Island",
        "title": "Island"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1872-1024x768.jpg",
        "alt": "No zombies allowed at this rest stop",
        "title": "No zombies allowed at this rest stop"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-first-leg/swizec/4906"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103068899_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-first-leg/swizec/4906"
        }}>{`A roadtrip: First leg`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103324153_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923"
        }}>{`A roadtrip: wherein Swizec is not to be trusted with important objects without supervision`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.chrystal-clear.com/2012/07/dubrovnik-from-above/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/102579870_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.chrystal-clear.com/2012/07/dubrovnik-from-above/"
        }}>{`Dubrovnik from Above`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b316a8e0-9e7b-4f09-b181-17635186ba0b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      